"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { createClient } from "@/lib/supabase/client";

/**
 * Unsichtbar, einmal global gemountet (app/layout.tsx, gleiches Muster wie
 * GuestDataMigrator): ein clientseitig ausgeloester Login/Logout OHNE volle
 * Seiten-Navigation (z.B. AuthModal, components/auth/auth-modal.tsx) aendert die
 * Supabase-Session, aber Server Components, die `supabase.auth.getUser()` beim
 * (Server-)Rendern pruefen (z.B. HeaderForHome/HeroSearchRow/AuthGatedHomeSection in
 * app/page.tsx), bekommen davon ohne einen neuen Request nichts mit - der
 * ausgeloggt wirkende Zustand blieb bisher bis zum naechsten manuellen Reload
 * sichtbar (Erik 2026-08-20: "Landingpage aktualisiert Login-Zustand nicht
 * automatisch"). `router.refresh()` rendert den Server-Baum der aktuellen Route mit
 * der frischen Session neu, ohne Client-State (z.B. Formulareingaben) zu verlieren.
 * `INITIAL_SESSION`/`TOKEN_REFRESHED` bewusst ausgenommen - kein echter
 * Login/Logout-Uebergang, ein Refresh dafuer waere ein unnoetiger Server-Roundtrip
 * bei jedem stillen Token-Refresh waehrend einer laufenden Sitzung.
 */
export function AuthRefreshListener() {
  const router = useRouter();

  useEffect(() => {
    const supabase = createClient();
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_IN" || event === "SIGNED_OUT") {
        router.refresh();
      }
    });
    return () => subscription.unsubscribe();
  }, [router]);

  return null;
}
